import { render, staticRenderFns } from "./SettingValuesPicker.vue?vue&type=template&id=13e6b844&"
import script from "./SettingValuesPicker.vue?vue&type=script&lang=ts&"
export * from "./SettingValuesPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports